import React from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import cx from 'classnames';
import { Remove, AddPhotoAlternate, Delete } from '@material-ui/icons';
import Button from '../Button/Button';
import Input, { INPUT_TYPES } from '../Input/Input';
import BannerActionsAndInfo from './BannerActionsAndInfo';
import FancyToggle from '../FancyToggle/FancyToggle';

const BannerCard = props => {
  const { config, isDeleted, configIndex, bannerConfigList, onChange } = props;
  return (
    <motion.li
      initial={{ opacity: 0, y: '-30%', x: '0%' }}
      animate={{ opacity: 1, y: '0%', x: '0%' }}
      exit={{ opacity: 0, y: '0%', x: '30%' }}
      transition={{
        ease: [0.18, 0.89, 0.39, 1.4],
        duration: 0.3,
      }}
      className={cx('bg-white m-auto max-w-md p-4 rounded shadow-md mb-10', {
        'pointer-events-none': isDeleted,
      })}>
      <BannerActionsAndInfo {...props} />
      <div className={cx({ 'opacity-50': isDeleted })}>
        <FancyToggle
          id={`${configIndex}.online`}
          name={`${configIndex}.online`}
          checked={bannerConfigList[configIndex].online}
          onChange={event => onChange(event, configIndex)}
          labelClassName="w-64"
          onText="ONLINE"
          offText="OFFLINE"
        />
        <div className="flex mt-4">
          <div className="flex justify-between mt-2 mr-8 w-24 h-16">
            <div className="flex flex-col justify-between">
              <div className="overflow-hidden relative">
                <Button
                  type="transparent"
                  className="p-0-important shadow-none-important h-5 pointer-events-none cursor-ppinter">
                  <AddPhotoAlternate
                    fontSize="small"
                    titleAccess="Upload photo"
                    className="text-darkGrey"
                  />
                </Button>
                <input
                  onChange={event => props.handleIconUpload(event, configIndex)}
                  className="absolute pin-t pin-l text-xl opacity-0 p-0-important z-10"
                  type="file"
                />
              </div>
              <Button
                onClick={() => props.removeIcon(configIndex)}
                type="transparent"
                className="p-0-important shadow-none-important h-5">
                <Delete
                  fontSize="small"
                  titleAccess="Delete photo"
                  className="text-darkGrey"
                />
              </Button>
            </div>
            <div className="icon_preview rounded w-16 h-16">
              {Boolean(config.icon) && (
                <img src={config.icon} alt="banner icon" width="100%" />
              )}
            </div>
          </div>
          <div className="flex-grow">
            <Input
              id={`${configIndex}.title`}
              name={`${configIndex}.title`}
              label="Title"
              type={INPUT_TYPES.TEXT}
              placeholder="Enter banner title"
              value={bannerConfigList[configIndex].title}
              onChange={event => onChange(event, configIndex)}
              inputClassName="shadow-inner bg-almostWhite"
            />
            <div className="relative">
              <Input
                defaultHeight={false}
                className="mt-4"
                inputClassName="shadow-inner bg-almostWhite h-16"
                id={`${configIndex}.description`}
                name={`${configIndex}.description`}
                label="Description *"
                type={INPUT_TYPES.TEXTAREA}
                placeholder="Enter banner description"
                value={bannerConfigList[configIndex].description}
                onChange={event => onChange(event, configIndex)}
              />
              <Button
                isBlock
                className="add_context_button absolute pin-b pin-l w-24 py-2"
                onClick={() => props.addNewContext(configIndex)}>
                Add Context
              </Button>
            </div>
            {Boolean(config.contexts.length) && (
              <ul className="list-reset mt-4">
                <li className="text-sm">Contexts</li>
                <AnimatePresence initial={false}>
                  {config.contexts.map((context, contextIndex) => {
                    return (
                      <motion.li
                        initial={{ opacity: 0.5, x: '-30%' }}
                        animate={{ opacity: 1, x: '0%' }}
                        exit={{ opacity: 0, x: '30%' }}
                        transition={{
                          ease: [0.18, 0.89, 0.39, 1.4],
                          duration: 0.3,
                        }}
                        positionTransition
                        className="flex mt-2"
                        key={context.id}>
                        <Input
                          id={`${configIndex}.contexts.${contextIndex}.key`}
                          name={`${configIndex}.contexts.${contextIndex}.key`}
                          type={INPUT_TYPES.TEXT}
                          placeholder="Enter key"
                          value={
                            bannerConfigList[configIndex].contexts[contextIndex]
                              .key
                          }
                          onChange={event => onChange(event, configIndex)}
                          className="w-32 mr-1"
                          inputClassName="shadow-inner bg-almostWhite"
                        />
                        <Input
                          id={`${configIndex}.contexts.${contextIndex}.value`}
                          name={`${configIndex}.contexts.${contextIndex}.value`}
                          type={INPUT_TYPES.TEXT}
                          placeholder="Enter value"
                          value={
                            bannerConfigList[configIndex].contexts[contextIndex]
                              .value
                          }
                          onChange={event => onChange(event, configIndex)}
                          className="flex-grow ml-1"
                          inputClassName="shadow-inner bg-almostWhite"
                        />
                        <Button
                          onClick={() =>
                            props.removeContext(configIndex, contextIndex)
                          }
                          type="transparent"
                          className="p-0-important shadow-none-important ml-4">
                          <Remove className="bg-lightRed text-red rounded-full" />
                        </Button>
                      </motion.li>
                    );
                  })}
                </AnimatePresence>
              </ul>
            )}
          </div>
        </div>
      </div>
    </motion.li>
  );
};

BannerCard.propTypes = {
  addNewContext: PropTypes.func.isRequired,
  bannerConfigList: PropTypes.array.isRequired,
  bannerState: PropTypes.string.isRequired,
  config: PropTypes.object.isRequired,
  configIndex: PropTypes.number.isRequired,
  handleIconUpload: PropTypes.func.isRequired,
  isDeleted: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  removeConfig: PropTypes.func.isRequired,
  removeContext: PropTypes.func.isRequired,
  removeIcon: PropTypes.func.isRequired,
  toggleDeleteWarningPopup: PropTypes.func.isRequired,
};

export default  BannerCard;
